import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconCruiseCabin = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconCruiseCabin",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    d: "M19.2 12.5V9.8c0-.99-.81-1.8-1.8-1.8H6.6c-.99 0-1.8.81-1.8 1.8v2.7c-.99 0-1.8.81-1.8 1.8v4.5h1.2l.46 1.38a.63.63 0 0 0 1.18 0l.46-1.38h11.4l.46 1.38c.09.25.32.42.59.42s.5-.17.6-.42l.45-1.38H21v-4.5c0-.99-.81-1.8-1.8-1.8m-8.1 0H6.6v-1.8c0-.5.4-.9.9-.9h3.6zm6.3 0h-4.5V9.8h3.6c.5 0 .9.4.9.9zm-5.37-6.86h2.21v-.68l-2.04.01zm.9-2.32h.65v.98h-.65z"
  }), _jsx("path", {
    d: "M15.56 2H8.32A1.3 1.3 0 0 0 7 3.32v2.63a1.3 1.3 0 0 0 1.32 1.32h1.84l-.5-1.18a.33.33 0 0 1 .3-.45h1.4l.26-1.07a.3.3 0 0 1 .31-.25h.34V2.98a.33.33 0 0 1 .33-.33h1.31a.33.33 0 0 1 .33.33V4.3h.33a.33.33 0 0 1 .33.33v1h.99a.33.33 0 0 1 .33.34v.38q-.09.46-.32.86a1.3 1.3 0 0 0 .97-1.26V3.32A1.3 1.3 0 0 0 15.57 2M8.65 4.3a.66.66 0 1 1 0-1.31.66.66 0 0 1 0 1.31"
  }), _jsx("path", {
    d: "M11.6 6.3h-1.14l.42.97h4.18q.38-.42.5-.98z"
  })]
}));
IconCruiseCabin.displayName = 'IconCruiseCabin';